import { PropsWithChildren } from 'react';
import { Skeleton } from './Skeleton';

type Props = {
    className?: string;
    height: string;
    isLoading: boolean;
    width: string;
};

export const SkeletonWrapper = ({ className, isLoading, width, height, children }: PropsWithChildren<Props>) => {
    if (isLoading) {
        return <Skeleton className={className} width={width} height={height} />;
    }

    return children;
};
